/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../../utils/money';
import { yardsToFurlongs } from '../../../utils/distance';
import { TrainerLink } from '../../../shared/links/ProfileLink';
import Abbr from '../../../shared/Abbr';
import HorseSireCell from './HorseSireCell';
import { numericAndDashSort } from '../../../utils/number';

const columns = [
    {
        key: 'horseName',
        header: 'horse sire',
        cell: relativeData => <HorseSireCell {...relativeData} />,
        sortFn: 'alphabetic',
    },
    {
        key: 'wins',
    },
    {
        key: 'runs',
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'places',
        header: () => (
            <Abbr
                breakpoint="fromMedium"
                title="placed"
            >
                pld
            </Abbr>
        ),
    },
    {
        key: 'trainerName',
        header: 'trainer',
        cell: ({ trainerName, trainerUid }) => (
            <TrainerLink
                className="ui-link_marked"
                trainerStyleName={trainerName}
                trainerUid={trainerUid}
            />
        ),
        sortFn: 'byLastName',
    },
    {
        key: 'totalPrizeMoney',
        header: 'total earnings',
        cell: ({ totalPrizeMoney }) => formatMoney(totalPrizeMoney),
    },
    {
        key: 'distanceYard',
        header: () => (
            <Abbr
                breakpoint="fromMedium"
                title="distance"
            >
                dist.
            </Abbr>
        ),
        cell: ({ distanceYard }) => yardsToFurlongs(distanceYard) || '—',
        sortFn: 'numericReverse',
    },
    {
        key: 'bestRpPostmark',
        header: 'best rpr',
        sortFn: numericAndDashSort('bestRpPostmark'),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/relativesTable/columns.jsx